import React from 'react';
import { COLORS } from '../constants/colors';

export const ResultViewRender = (props: { size: string }) => {
  return (
    <div
      style={{
        marginTop: '10px',
        marginBottom: '10px',
        width: '90vw',
        minWidth: '275px',
        maxWidth: '350px',
        height: 'auto',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          color: `${COLORS.orange}`,
          background: 'white',
          padding: '40px',
          paddingTop: '20px',
          paddingBottom: '15px',
          fontWeight: 700,
          textTransform: 'uppercase',
          height: '100%',
          letterSpacing: '1px',
        }}
      >
        your size is
        <div
          style={{
            fontSize: '5em',
            lineHeight: '1em',
            fontWeight: 100,
            margin: '20px',
            marginTop: '0',
            marginBottom: '0',
          }}
        >
          {props.size}
        </div>
      </div>
    </div>
  );
};
